import React from "react"

import { WithClassName } from "shared/types/WithClassName"

import { useCreateMultipleTeamMembersFormViewModel } from "../model/useCreateMultipleTeamMembersFormViewModel"
import { CreateTeamMemberFormModel } from "../types/CreateTeamMemberFormModel"
import { CreateTeamMemberFormView } from "./CreateTeamMemberFormView"

export interface SendMultipleTeamInvitationsFormProps
  extends WithClassName,
    CreateTeamMemberFormModel {
  id: string
}

export const CreateMultipleTeamMembersForm = React.memo(
  (props: SendMultipleTeamInvitationsFormProps) => {
    return (
      <CreateTeamMemberFormView
        {...useCreateMultipleTeamMembersFormViewModel(props)}
      />
    )
  }
)
